<template>
  <div class="cashbox">
    <router-view/>
  </div>
</template>

<script>
  export default {

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/app/cashbox/Cashbox.Entry.vue